/** @type {import('tailwindcss').Config} */
export default {
  content: ["./index.html", "./src/**/*.{js,ts,jsx,tsx}", "./lib/**/*.{js,ts,jsx,tsx}"],
  theme: {
    extend: {
      colors: {
        content: {
          base: "#FFF",
          soft: "#A69E92",
          disabled: "#474642",
        },
        informative: {
          base: "#23B4C9",
          50: "#ECFEFF",
          100: "#CFFAFE",
          200: "#A5F3FC",
          300: "#67E8F9",
          400: "#22D3EE",
          500: "#06B6D4",
          600: "#0891B2",
          700: "#0E7490",
          800: "#155E75",
          900: "#164E63",
          950: "#083344",
        },
        warning: {
          base: "#D67D39",
          soft: "#A65028",
          soft2: "#E8BC89",
          strong: "#E8BC89",
          bold: "#F9EDDB",
          subtle: "#6C3722",
          50: "#FCF7F0",
          100: "#F9EDDB",
          200: "#F1D7B7",
          300: "#E8BC89",
          400: "#E09F64",
          500: "#D67D39",
          600: "#C8672E",
          700: "#A65028",
          800: "#854027",
          900: "#6C3722",
          950: "#3A1A10",
        },
        error: {
          base: "#EF4444",
          soft: "#B91C1C",
          strong: "#FCA5A5",
          bold: "#FEE2E2",
          subtle: "#7F1D1D",
          50: "#FEF2F2",
          100: "#FEE2E2",
          200: "#FECACA",
          300: "#FCA5A5",
          400: "#F87171",
          500: "#EF4444",
          600: "#DC2626",
          700: "#B91C1C",
          800: "#991B1B",
          900: "#7F1D1D",
          950: "#450A0A",
        },
        success: {
          base: "#15A462",
          soft: "#14814F",
          strong: "#85F0BE",
          bold: "#DCFCEC",
          subtle: "#135438",
          50: "#F0FDF6",
          100: "#DCFCEC",
          200: "#BAF8DA",
          300: "#85F0BE",
          400: "#49DF99",
          500: "#21C97B",
          600: "#15A462",
          700: "#14814F",
          800: "#156642",
          900: "#135438",
          950: "#052E1D",
        },
        darkBrand: {
          50: "#A69E92",
          100: "#999188",
          200: "#8B857D",
          300: "#7D7872",
          400: "#726E69",
          500: "#474642",
          600: "#333230",
          700: "#2E2D2C",
          800: "#1F1E1D",
          900: "#141414",
          950: "#0A0A0A",
        },
        accentBrand: {
          50: "#FAEDCD",
          100: "#F2E4BF",
          200: "#E5D6AE",
          300: "#D9C89C",
          400: "#C7B587",
          500: "#B8A576",
          600: "#99815C",
          700: "#756041",
          800: "#5C4A2E",
          900: "#524531",
          950: "#524531",
        },
        brand: {
          50: "#E7D5FF",
          100: "#FFF6E8",
          200: "#FFEED5",
          300: "#FFE1B3",
          400: "#FDD598",
          500: "#F8CC8B",
          600: "#EBBE7A",
          700: "#C49F66",
          800: "#A9834A",
          900: "#886736",
          950: "#654B24",
        },
        stroke: {
          base: "#474642",
          soft: "#333230",
          strong: "#726E69",
          error: "#EF4444",
        },
      },
      backgroundImage: {
        header: "radial-gradient(720% 100.02% at 100% 38%, rgba(31, 30, 29, 0.96) 0%, rgba(20, 20, 20, 0.96) 100%)",
        dialog: "radial-gradient(51.67% 51.19% at 51.67% 0%, #2E2D2C 0%, #141414 100%)",
        homeBtn: "linear-gradient(180deg, #2E2D2C 0%, #1F1E1D 50.48%, #2E2D2C 100%)",
        grdPrimary: "radial-gradient(50% 100% at 50% 0%, #B8A576 0%, #756041 100%)",
        grdPrimaryAlt: "linear-gradient(180deg, #524531 0%, #5C4A2E 100%)",
        grdSecondary: "radial-gradient(50% 100% at 50% 0%, #2E2D2C 0%, #1F1E1D 100%)",
        grdSecondaryAlt: "linear-gradient(180deg, #2E2D2C 0%, #333230 100%)",
        bottomMenu: "radial-gradient(33.48% 103.75% at 52.2% 0%, #886736 0%, #292218 100%)",
        bottomNavBtnRound: "linear-gradient(180deg, #F8CC8B 0%, #5C4A2E 100%)",
        bottomNavBtnRoundRimLight: "radial-gradient(50% 25% at 50% 100%, #FDD598 0%, rgba(41, 34, 24, 0.00) 100%)",
        bottomNavBtnIndicatorActive: "radial-gradient(44.58% 50% at 50% 100%, #70623e 0%, #ffffff00 100%)",
        bottomNavBtnIndicator: "",
        pageTitle: "linear-gradient(180deg, #FFF 19.11%, #8B857D 71.43%)",
        tabNavSecondary: "linear-gradient(180deg,#2E2D2C 0%, #1F1E1D 100%)",
        referFriendTopSection:
          "radial-gradient(73.33% 38.02% at 73.33% 58.07%, #7f694733 0%, rgba(0, 0, 0, 0.00) 100%)",
        timerProgressBar:
          "linear-gradient(#1F1E1D,#1F1E1D),linear-gradient(90deg, #756041 0%, #C49F66 70%, #B7A575 100%)",
        timerProgressStripes:
          "linear-gradient(-45deg,rgba(255,255,255,.20) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.20) 50%,rgba(255,255,255,.20) 75%,transparent 75%,transparent)",
        card: "radial-gradient(46.81% 58.96% at 50% 0%,#333230 0%,#141414 100%)",
        flipClock: "linear-gradient(180deg, #333230 0%, #2E2D2C 42%, #1F1E1D 46.5%, #141414 100%)",
      },
      backgroundColor: {
        backdrop: "#0A0A0AD9",
      },
    },
  },
  plugins: [import("@tailwindcss/typography")],
};
